import { Component, HostListener, OnDestroy } from '@angular/core';
import { TermsDialogComponent } from './components/terms-and-conditions/terms-dialog/terms-dialog.component';
import { PrivacyDialogComponent } from './components/privacy-dialog/privacy-dialog/privacy-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { environment } from 'src/environments/environment';
import { EventService } from './services/event.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { HttpService } from './services/http.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { VersionService } from './services/version.service';
import { SwUpdate } from '@angular/service-worker';
import { Router, NavigationEnd } from '@angular/router';
import { IPAPIService } from './services/ipapi.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { FvrZeropaySupportPopupService } from './components/zeropay-support/fvr-zeropay-support-popup.service';

declare let gtag: Function;
@AutoUnsubscribe()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [],
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private matDialog: MatDialog,
    private snackBar: MatSnackBar,
    private supportService: FvrZeropaySupportPopupService,
    private eventService: EventService,
    private httpService: HttpService,
    private version: VersionService,
    private swUpdate: SwUpdate,
    public router: Router,
    private route: ActivatedRoute,
    private ip: IPAPIService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    this.ip.get();

    // this.route.params.subscribe((p: any) => {
    //   this.countryCode = p?.country;
    // });

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-ZB69TG340J', {
          page_path: event.urlAfterRedirects,
        });
      }
    });

    this.iconRegistry.addSvgIcon('whatsapp-icon', sanitizer.bypassSecurityTrustResourceUrl("../assets/whatsapp.svg"));
  }

  public countryCode: string | undefined;

  public scrollTo(elementId: string): void {
    (document.querySelector(`#${elementId}`) as Element).scrollIntoView({
      behavior: 'smooth',
    });
  }

  public subscribeForm = new FormGroup({
    email: new FormControl(null, [Validators.required, Validators.email]),
  });

  public displayScrollToTop = false;
  public open = false;
  public redirect = environment.applyRedirect;

  public showHowItWorks = false;
  public showLogoOnToolbar = true;
  public loading = false;
  public subscribed = false;

  public prefilledMessage: string = '';
  public selectedReason: number = -1;

  ngOnInit(): void {
    this.version.checkForUpdate('zeropay');

    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        window.location.reload();
      });
    }

    this.enableScroll();
    setTimeout(() => {
      this.showHowItWorks = true;
    });
    setTimeout(() => {
      this.showLogoOnToolbar = true;
    });

    this.eventService.howItWorksDisplay.subscribe((value: boolean) => {
      setTimeout(() => {
        this.showHowItWorks = value;
      }, 100);
    });

    this.eventService.mobileDisplayLogoToolbar.subscribe((value: boolean) => {
      setTimeout(() => {
        this.showLogoOnToolbar = value;
      }, 100);
    });

    this.eventService.prefillContact.subscribe((value: { idNumber: any }) => {
      setTimeout(() => {
        this.selectedReason = 4;
        this.prefilledMessage = `Customer Limit Increase Request. ID Number: ${value.idNumber}`;
      });

      setTimeout(() => {
        this.supportService.showContactDialog();
      }, 100);
    });
  }

  prepareRoute(outlet: RouterOutlet) {
    return (
      outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation
    );
  }

  @HostListener('window:scroll', ['$event']) onWindowScroll(e: any) {
    if (e.target['scrollingElement'].scrollTop >= 300) {
      setTimeout(() => (this.displayScrollToTop = true));
    } else {
      setTimeout(() => (this.displayScrollToTop = false));
    }
  }

  showTerms() {
    this.matDialog.open(TermsDialogComponent, {
      width: '100%',
    });
  }

  showPrivacy() {
    this.matDialog.open(PrivacyDialogComponent, {
      width: '100%',
    });
  }

  disableScroll() {
    window.addEventListener('scroll', function (e) {
      if (window.scrollY >= 0) {
        document.documentElement.style.overflow = 'hidden';
      }
    });
  }

  enableScroll() {
    window.addEventListener('scroll', function (e) {
      if (window.scrollY >= 200) {
        document.documentElement.style.overflow = 'auto';
      }
    });
  }

  showContact() {
    this.supportService.showContactDialog();
  }

  async submitSubscribe(form: FormGroup) {
    if (form.valid) {
      this.loading = true;
      await this.httpService.subscribe(form.value);

      setTimeout(() => {
        this.loading = false;
        this.subscribeForm.reset();
        this.subscribeForm.setErrors(null);
        this.subscribeForm.updateValueAndValidity();
        this.subscribed = true;
        this.snackBar.open('Thank you for subscribing!', '', {
          duration: 3000,
        });
      }, 500);
    } else {
      this.snackBar.open('A valid email address is required', '', {
        duration: 3000,
      });
    }
  }

  ngOnDestroy(): void {}
}
